import { PagedRequest } from './PagedRequest';

export default class DeviceRequest extends PagedRequest<DeviceRequest> {
  exactLocationId: number | null = null;
  withinLocationPath: string | null = null;
  deviceIdentifier: string | null = null;
  measurersPackage: string | null = null;
}
